import { defineStore } from 'pinia';

export type TStatus = 'alert' | 'success' | 'warning' | 'default';
export type TDisplay = 'none' | 'block';

export interface IStatusState {
    display: TDisplay;
    status: TStatus;
    copy: string;
}

export interface IStatusWithButton {
    message: string;
}

const stateDefaults: IStatusState = {
    display: 'none',
    status: 'default',
    copy: '',
};

export const useStatusStore = defineStore({
    id: 'status',
    state: (): IStatusState => stateDefaults,
    actions: {
        clearStatus(): void {
            Object.assign(this.$state, {
                display: 'none',
                status: 'default',
                copy: '',
            });
        },
        setStatusError(message: string): void {
            this.$state = {
                display: 'block',
                status: 'warning',
                copy: message,
            };
        },
        setStatusSuccess(message: string): void {
            this.$state = {
                display: 'block',
                status: 'success',
                copy: message,
            };
        },
        setStatusWarning(message: string): void {
            this.$state = {
                display: 'block',
                status: 'alert',
                copy: message,
            };
        },
        setStatusWithButton(status: IStatusWithButton): void {
            this.$state = {
                display: 'block',
                status: 'warning', // or some other logic to determine the status
                copy: status.message,
            };
        },
    },
});
